import { render, staticRenderFns } from "./OSpinner.vue?vue&type=template&id=9d515184&scoped=true&"
import script from "./OSpinner.vue?vue&type=script&lang=js&"
export * from "./OSpinner.vue?vue&type=script&lang=js&"
import style0 from "./OSpinner.vue?vue&type=style&index=0&id=9d515184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d515184",
  null
  
)

export default component.exports